/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrganizationLogoUploadUrlDtoBase
 * auto generated base class for the model OrganizationLogoUploadUrlDtoModel.
 */
export const OrganizationLogoUploadUrlDtoModelBase = ModelBase
  .named('OrganizationLogoUploadUrlDto')
  .props({
    __typename: types.optional(types.literal("OrganizationLogoUploadUrlDto"), "OrganizationLogoUploadUrlDto"),
    uploadUrl: types.union(types.undefined, types.string),
    readUrl: types.union(types.undefined, types.string),
    objectPath: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationLogoUploadUrlDtoModelSelector extends QueryBuilder {
  get uploadUrl() { return this.__attr(`uploadUrl`) }
  get readUrl() { return this.__attr(`readUrl`) }
  get objectPath() { return this.__attr(`objectPath`) }
}
export function selectFromOrganizationLogoUploadUrlDto() {
  return new OrganizationLogoUploadUrlDtoModelSelector()
}

export const organizationLogoUploadUrlDtoModelPrimitives = selectFromOrganizationLogoUploadUrlDto().uploadUrl.readUrl.objectPath
